import { memo } from 'react';
import { Grid, Stack, useMediaQuery } from '@chakra-ui/react';

import { breakpoints } from 'app/themeConfig';
import { useHeaderBoundStore } from 'app/selectors';
import { TabCard, TabInfo } from './ui';

import { HEADER_BREAKPOINT } from 'constants/global';

const HeaderTabPage = () => {
  const { headerMenuData, updateHeaderMenuState } = useHeaderBoundStore();
  const [isLaptop, isHeaderBreakpoint] = useMediaQuery([
    `(min-width: ${breakpoints.laptop})`,
    `(max-width: ${parseInt(breakpoints[HEADER_BREAKPOINT]) - 1}px)`,
  ]);

  const { cardsData = null, ...infoData } = headerMenuData;

  return (
    <Stack
      w="full"
      h="full"
      maxW={{ [HEADER_BREAKPOINT]: '1600px', xxd: 'unset' }}
      direction={{ mobile: 'column-reverse', [HEADER_BREAKPOINT]: 'row' }}
      gap={{ mobile: '23px', tablet: '40px', [HEADER_BREAKPOINT]: '60px' }}
      align="start"
      justify={{ mobile: 'start', [HEADER_BREAKPOINT]: 'space-between' }}
      pt="1px"
    >
      <Grid
        w="full"
        templateColumns={{
          mobile: '1fr',
          xxm: 'repeat(2, 1fr)',
          tablet: 'repeat(6, 1fr)',
          mg: 'repeat(3, 1fr)',
          [HEADER_BREAKPOINT]: 'repeat(3, 1fr)',
          xds: 'repeat(auto-fill, 286px)',
        }}
        autoRows={{ xxm: '180px', [HEADER_BREAKPOINT]: '1fr' }}
        gap={{ mobile: '16px', [HEADER_BREAKPOINT]: '20px' }}
      >
        {isLaptop && isHeaderBreakpoint && <TabInfo {...infoData} />}

        {cardsData?.map((cardData, i) => (
          <TabCard
            key={i}
            updateHeaderMenuState={updateHeaderMenuState}
            gridColumn={{ tablet: ['span 3', 'span 3'][i] ?? 'span 2', mg: 'unset' }}
            {...cardData}
          />
        ))}
      </Grid>

      <TabInfo {...infoData} hideBelow={HEADER_BREAKPOINT} />
      <TabInfo {...infoData} hideFrom="laptop" />
    </Stack>
  );
};

export default memo(HeaderTabPage);
